import Interface from "../../../views/administrador/Fracttal/Interface";




const routes_fracttal = [
  {
    path: "/Interface",
    name: "Interface Fracttal",
    icon: "",
    component: Interface,
    doNotShow: true,
  },
 
];

export default routes_fracttal;
